import { MdQuiz } from 'react-icons/md';
import { Resources } from '../../resource';
import { MainPage } from './main-page';

export const name = Resources.worldCupFaq;

export const list = MainPage;

export const icon = MdQuiz;

export const options = { label: 'resource.worldCupFaq' };
